import { formValueSelector } from 'redux-form';

export const imageSelector = (state, form) => formValueSelector(form)(state, 'image');
export const retinaImageSelector = (state, form) => formValueSelector(form)(state, 'retina_image');
export const additionalImageSelector = (state, form) => formValueSelector(form)(state, 'additional_page_image');
export const imagePositionSelector = (state, form) => formValueSelector(form)(state, 'position_image');
